import { Table, TableBody, TableHead, TableHeader, TableRow } from '@/components/shadcn/table'
import { MessagesLandingMenuItem } from './types'
import { useMenuOperations } from './useMenuOperations'
import { MenuToolbar } from './MenuToolbar'
import { MenuItemsRenderer } from './MenuItemsRenderer'

// Main component
export function MenuTable({ data: initialData }: { data: MessagesLandingMenuItem[] }) {
  const {
    menuItems,
    setMenuItems,
    expandedItems,
    isExpanded,
    hasChanged,
    toggleItem,
    toggleExpandCollapse,
    moveItemUp,
    moveItemDown,
    addChildItem,
    deleteItem,
    editItem,
    addRootItem,
    handleSave,
    initialData: originalData,
  } = useMenuOperations(initialData)

  return (
    <div className="w-full">
      <MenuToolbar
        isExpanded={isExpanded}
        hasChanged={hasChanged}
        toggleExpandCollapse={toggleExpandCollapse}
        addRootItem={addRootItem}
        handleSave={handleSave}
        resetMenuItems={() => setMenuItems(originalData)}
      />

      <div className="rounded-md border bg-white">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead className="w-10 text-base text-foreground">Icon</TableHead>
              <TableHead className="text-base text-foreground">Menu Item</TableHead>
              <TableHead className="text-base text-foreground">Page ID</TableHead>
              <TableHead className="text-base text-foreground">Roles</TableHead>
              <TableHead className="text-base text-foreground">Actions</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            <MenuItemsRenderer
              menuItems={menuItems}
              expandedItems={expandedItems}
              toggleItem={toggleItem}
              moveItemUp={moveItemUp}
              moveItemDown={moveItemDown}
              addChildItem={addChildItem}
              deleteItem={deleteItem}
              editItem={editItem}
            />
          </TableBody>
        </Table>
      </div>
    </div>
  )
}
